export default (context) => {
    context.is_clear = true
    context.code = false
}